import { request } from '@/api/base';
import { snakify } from '@/helpers/common';
import { CLIENT_ENVS } from '@/helpers/constants';

export enum AnalyticsEventName {
  NEW_SESSION = 'new_session',
  VISIT = 'visit',

  COOKIE_BANNER = 'cookie_banner_ok',

  GAME_REAL_GAME = 'game_{{game_name}}_real_click',
  GAME_DEMO_GAME = 'game_{{game_name}}_demo_click',

  TABBAR__BUTTONS__HOME_BUTTON__CLICK = 'tabbar__buttons__home_button__click',
  TABBAR__BUTTONS__SPORTS_BUTTON__CLICK = 'tabbar__buttons__sports_button__click',
  TABBAR__BUTTONS__SUPPORT_BUTTON__CLICK = 'tabbar__buttons__support_button__click',
  TABBAR__BUTTONS__SEARCH_BUTTON__CLICK = 'tabbar__buttons__search_button__click',

  LOBBY__PRIME_GAME__BUTTON__CLICK = 'lobby__prime_game__button__click',
  LOBBY__PROMO_SLIDER__BANNER__CLICK = 'lobby__promo_slider__banner__click',
  LOBBY__REGISTRATION__FORM__TOUCHED = 'lobby__registration__form__touched',
  LOBBY__REGISTRATION__FORM__SUBMIT = 'lobby__registration__form__submit',
  LOBBY__REGISTRATION__FORM__ERROR = 'lobby__registration__form__error',
  LOBBY__REGISTRATION__FORM__SUCCESS = 'lobby__registration__form__success',
  LOBBY__FILTER_GAMES__CATEGORY__CLICK = 'lobby__filter_games__category__click',
  LOBBY__FILTER_GAMES__ALL_THEMES__CLICK = 'lobby__filter_games__all_themes__click',
  LOBBY__MOBILE_APP_BANNER__LINK__CLICK = 'lobby__mobile_app_banner__link__click',

  MODAL__REGISTRATION__FORM__APPEARANCE = 'modal__registration__form__appearance',
  MODAL__REGISTRATION__FORM__TOUCHED = 'modal__registration__form__touched',
  MODAL__REGISTRATION__FORM__SUBMIT = 'modal__registration__form__submit',
  MODAL__REGISTRATION__FORM__SUCCESS = 'modal__registration__form__success',
  MODAL__REGISTRATION__FORM__ERROR = 'modal__registration__form__error',
  MODAL__REGISTRATION__BONUS_REGISTER__BUTTON__CLICK = 'modal__registration__bonus_register__button__click',

  LOBBY__RANDOM_ZONE__BUTTON__CLICK = 'lobby__random_zone__button__click',

  MODAL__ADDITIONAL_USER_DATA__FORM__APPEARANCE = 'modal__additional_user_data__form__appearance',
  MODAL__ADDITIONAL_USER_DATA__STEP__APPEARANCE = 'modal__additional_user_data__step_{{step}}__appearance',
  MODAL__ADDITIONAL_USER_DATA__FORM__TOUCHED = 'modal__additional_user_data__form__touched',
  MODAL__ADDITIONAL_USER_DATA__FORM__SUBMIT = 'modal__additional_user_data__form__submit',
  MODAL__ADDITIONAL_USER_DATA__FORM__SUCCESS = 'modal__additional_user_data__form__success',
  MODAL__DEPOSIT_EXIT_POPUP__ACTIVATE_BONUS__CLICK = 'modal__deposit_exit_popup_v2__activate_bonus__click',
  MODAL__DEPOSIT_EXIT_POPUP__CLOSE_CROSS__CLICK = 'modal__deposit_exit_popup_v2__close_cross__click',
  MODAL__DEPOSIT_EXIT_POPUP__BUTTON_CLOSE__CLICK = 'modal__deposit_exit_popup_v2__button_close__click',
  MODAL__DEPOSIT_EXIT_POPUP__APPEARANCE = 'modal__deposit_exit_popup_v2__appearance',
  MODAL__REG_EXIT_POPUP__APPEARANCE = 'modal__reg_exit_popup__appearance',
  MODAL__REG_EXIT_POPUP__CLOSE_CROSS__CLICK = 'modal__reg_exit_popup__close_cross__click',
  MODAL__REG_EXIT_POPUP_NO__CLICK = 'modal__reg_exit_popup__no__click',
  MODAL__GENDER_SELECT__APPEARANCE = 'modal__gender_select__appearance',
  MODAL__GENDER_SELECT__FORM__SUBMIT = 'modal__gender_select__form__submit',

  LOGIN_APPEARANCE = 'login_appearance',
  LOGIN_TOUCHED = 'login_touched',
  LOGIN_SUCCESS = 'login_success',
  MODAL__LOGIN__FORM__ERROR = 'modal__login__form__error',
  LU_HOME_TOP = 'lu_home_top_click',

  MOBILE_APP_PAGE__VISIT = 'mobile_app_page__visit',
  MOBILE_APP_PAGE__ANDROID_APP_ICON__LINK__CLICK = 'mobile_app_page__android_app_icon__link__click',
  MOBILE_APP_PAGE__IOS_APP_ICON__LINK__CLICK = 'mobile_app_page__ios_app_icon__link__click',

  HEADER__BUTTONS__NOTIFICATIONS_BUTTON__CLICK = 'header__buttons__notifications_button__click',
  HEADER__BUTTONS__SUPPORT_BUTTON__CLICK = 'header__buttons__support_button__click',
  HEADER__BUTTONS__NAVIGATION_LINK__CLICK = 'header__buttons__navigation_link__click',

  FOOTER__MOBILE_APP__LINK__CLICK = 'footer__mobile_app__link__click',
  FOOTER__ANDROID_APP_ICON__LINK__CLICK = 'footer__android_app_icon__link__click',
  FOOTER__IOS_APP_ICON__LINK__CLICK = 'footer__ios_app_icon__link__click',

  REG_BUTTON_TOP = 'reg_button_top_click',
  LOG_IN_TOP = 'log_in_top_click',
  DEPOSIT_TOP = 'deposit_top_click',

  EMAIL_CONFIRMATION_POPUP__BUTTON_CLOSE__CLICK = 'email_confirmation_popup__button_close__click',
  EMAIL_CONFIRMATION_POPUP__FIRST_APPEARANCE = 'email_confirmation_popup__first_appearance',
  EMAIL_CONFIRMATION_POPUP__SUBSEQUENT_APPEARANCE = 'email_confirmation_popup__subsequent_appearance',
  EMAIL_CONFIRMED = 'email_confirmed',

  MOBILE_APP_PROMOTION_POPUP__BUTTON_CLOSE__CLICK = 'mobile_app_promotion_popup__button_close__click',
  MOBILE_APP_PROMOTION_POPUP__FIRST_APPEARANCE = 'mobile_app_promotion_popup__first_appearance',
  MOBILE_APP_PROMOTION_POPUP__SUBSEQUENT_APPEARANCE = 'mobile_app_promotion_popup__subsequent_appearance',
  MOBILE_APP_PROMOTION_POPUP__IOS_APP__LINK__CLICK = 'mobile_app_promotion_popup__ios_app__link__click',
  MOBILE_APP_PROMOTION_POPUP__ANDROID_APP__LINK__CLICK = 'mobile_app_promotion_popup__android_app__link__click',
  MOBILE_APP_PROMOTION_POPUP__MOBILE_APP__LINK__CLICK = 'mobile_app_promotion_popup__mobile_app__link__click',

  MODAL__SEARCH__OVERALL__APPEARANCE = 'modal__search__overall__appearance',
  MODAL__SEARCH__INPUT__TOUCHED = 'modal__search__input__touch',
  MODAL__SEARCH__RESULT_SUCCESS__APPEARANCE = 'modal__search__result_success__appearance',
  MODAL__SEARCH__RESULT_FAILURE__APPEARANCE = 'modal__search__result_failure__appearance',
  MODAL__SEARCH__OVERALL__CLOSE = 'modal__search__overall__close',
  MODAL__SEARCH__PLAYERS_CHOICE_TAB__CLICK = 'modal__search__players_choice_tab__click',

  GAME_SEARCH = 'game_search_click',
  GAME_ALL_PROVIDERS = 'game_all_providers_click',
  GAME_ALL_PROVIDERS_PROVIDER = 'game_all_providers_{{provider_name}}_click',

  GAME_OPEN__ACTIONS_PANEL__SEARCH_BUTTON__CLICK = 'game_open__actions_panel__search_button__click',
  GAME_OPEN__ACTIONS_PANEL__DEPOSIT_BUTTON__CLICK = 'game_open__actions_panel__deposit_button__click',
  GAME_OPEN__ACTIONS_PANEL__FAVORITE_BUTTON__CLICK = 'game_open__actions_panel__favorite_button__click',
  GAME_OPEN__ACTIONS_PANEL__WAGER_LABEL__CLICK = 'game_open__actions_panel__wager_label__click',

  PROMO__PROMOCODE_ACTIVATION__SUCCESS = 'promo__promocode_activation__success',
  PROMO__PROMOCODE_ACTIVATION__FAILURE = 'promo__promocode_activation__failure',

  PROMO__TAB__SELECTION = 'promo__tab__selection',

  PROMO__BONUS_CARD__ACTIVATE__SUCCESS = 'promo__bonus_card__activate__success',
  PROMO__BONUS_CARD__ACTIVATE__FAILURE = 'promo__bonus_card__activate__failure',
  PROMO__BONUS_CARD__CANCEL__SUCCESS = 'promo__bonus_card__cancel__success',
  PROMO__BONUS_CARD__CANCEL__FAILURE = 'promo__bonus_card__cancel__failure',
  PROMO__BONUS_CARD__PLAY = 'promo__bonus_card__play',

  PROMO__EXCHANGE_CP_MODAL__EXCHANGE__SUCCESS = 'promo__exchange_cp_modal__exchange__success',
  PROMO__EXCHANGE_CP_MODAL__EXCHANGE__FAILURE = 'promo__exchange_cp_modal__exchange__failure',

  PROFILE__VERIFICATION__UPLOADER__UPLOAD = 'profile__verification__uploader__upload',
  PROFILE__VERIFICATION__ERROR__SHOW = 'profile__verification__error__show',
  PROFILE__NAVBAR__LINK__CLICK = 'profile__navbar__link__click',

  MODAL__DEPOSIT__DEPOSIT_BUTTON_STEP_1__CLICK = 'modal__deposit__deposit_button_step_1__click',
  MODAL__DEPOSIT__AMOUNT_INPUT__TOUCHED = 'modal__deposit__amount_input__touch',
  MODAL__DEPOSIT__PREDEFINED_SUM__CLICK = 'modal__deposit__predefine_sum__click',
  MODAL__DEPOSIT__PROMO_CODE_FORM__TOUCHED = 'modal__deposit__promo_code_form__touch',
  MODAL__DEPOSIT__BACK_BUTTON__CLICK = 'modal__deposit__back_button__click',
  MODAL__DEPOSIT__PAYMENT_FORM__PREVIOUSLY_USED__CLICK = 'modal__deposit__payment_form__previously_used__click',
  MODAL__DEPOSIT__SELECTOR_PAYMENT_METHOD__CLICK = 'modal__deposit__selector_payment_method__click',
  MODAL__DEPOSIT__PAYMENT_FORM__ERROR_TEXT = 'modal__deposit__payment_form__error_text',
  MODAL__DEPOSIT__DEPOSIT_BUTTON_STEP_2__SUBMIT = 'modal__deposit__deposit_button_step_2__submit',
  MODAL__DEPOSIT__PAYMENT_FORM__PREVIOUSLY_USED__TOUCHED = 'modal__deposit__payment_form__previously_used__touched',
  MODAL__DEPOSIT__PAYMENT_FORM__SUCCESS_RESPONSE = 'modal__deposit__payment_form__success_response',
  MODAL__DEPOSIT__PAYMENT_FORM__COPY_CRYPTO_ADRESS = 'modal__deposit__payment_form__copy_crypto_adress',
  MODAL__DEPOSIT__ATTACHED_BONUS__CLICK = 'modal__deposit__attached_bonus__click',
  MODAL__DEPOSIT__PAYMENT_FORM__TOUCHED = 'modal__deposit__payment_form__touched',
  MODAL__DEPOSIT__PAYMENT_FORM__FAILURE_RESPONSE = 'modal__deposit__payment_form__failure_response',
  MODAL__DEPOSIT__PROMO_CODE_FORM__CANCEL = 'modal__deposit__promo_code_form__cancel',
  MODAL__DEPOSIT__PROMO_CODE_FORM__ADD = 'modal__deposit__promo_code_form__add',
  MODAL__DEPOSIT__TURN_ON_BONUSES__CLICK = 'modal__deposit__turn_on_bonuses__click',
  MODAL__DEPOSIT__TURN_OFF_BONUSES__CLICK = 'modal__deposit__turn_off_bonuses__click',
  MODAL__DEPOSIT__CLOSE = 'modal__deposit__overall__close',
  MODAL__REG_EXIT_POPUP1__REGISTER__CLICK = 'modal__reg_exit_popup1__register__click',
  MODAL__REG_EXIT_POPUP1_CROSS__CLICK = 'modal__reg_exit_popup1_cross__click',
  MODAL__REG_EXIT_POPUP1__APPEARANCE__CLICK = 'modal__reg_exit_popup1__appearance__click',
  MODAL__REG_EXIT_POPUP1__APPEARANCE = 'modal__reg_exit_popup1__appearance',
  MODAL__REG_EXIT_POPUP__YES__CLICK = 'modal__reg_exit_popup__yes__click',
  MODAL__DEPOSIT__OVERALL__APPEARANCE = 'modal__deposit__overall__appearance',

  PROFILE__PERSONAL__FORM_SUBMIT__ERROR = 'profile__personal__form_submit__error',
  PROFILE__PERSONAL__FORM_SUBMIT__SUCCESS = 'profile__personal__form_submit__success',
  PROFILE__PERSONAL__PROMOTIONAL_SETTINGS_SWITCHER__CLICK = 'profile__personal__promotional_settings_switcher__click',
  PROFILE__SECURITY__2FA__ACTIVATE = 'profile__security__2fa__activate',
  PROFILE__SECURITY__CHANGE_PASSWORD__SUCCESS = 'profile__security__change_password__success',

  MODAL__WITHDRAW__SUBMIT_BUTTON__CLICK = 'modal__withdraw__submit_button__click',

  HEADER__SIGN_OUT__BUTTON__CLICK = 'header__sign_out__button__click',
  TABBAR__SIGN_OUT__BUTTON__CLICK = 'tabbar__sign_out__button__click',

  MODAL__LOGIN__GOOGLE_AUTH_BUTTON_CLICK = 'modal__login__google_auth_button_click',
  MODAL__WELCOME_BACK__GOOGLE_AUTH_BUTTON_CLICK = 'modal__welcome_back__google_auth_button_click',
  MODAL__REGISTRATION__GOOGLE_AUTH_BUTTON_CLICK = 'modal__registration__google_auth_button_click',
}

export type CommonAttributes = {
  sessionId?: string; // field is required for the backend
  eventId?: string;
  userId?: number;
  email?: string;
  additionalData?: string;
  createdAt?: number; // field is required for the backend
  updatedAt?: number; // field is required for the backend
};

export type EventWithPayload =
  | {
      name: AnalyticsEventName.NEW_SESSION;
      attributes: CommonAttributes & {
        device?: {
          deviceType?: string;
          deviceName?: string;
          os?: string;
          osVersion?: string;
          browser?: string;
          browserVersion?: string;
          screenSizeWidth?: number;
          screenSizeHeight?: number;
          internetSpeedMbps?: number;
        };
        location?: {
          countryCode?: string;
          defaultCurrency?: string;
          ip?: string;
          regionCode?: string;
        };
      };
    }
  | {
      name: AnalyticsEventName.VISIT;
      attributes?: CommonAttributes & {
        stag?: string;
        landingUrl?: string;
      };
    }
  | {
      name: AnalyticsEventName.GAME_DEMO_GAME;
      attributes?: CommonAttributes;
      dynamicParams: { game_name: string };
    }
  | {
      name: AnalyticsEventName.GAME_REAL_GAME;
      attributes?: CommonAttributes;
      dynamicParams: { game_name: string };
    }
  | {
      name: AnalyticsEventName.TABBAR__BUTTONS__HOME_BUTTON__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.TABBAR__BUTTONS__SPORTS_BUTTON__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.COOKIE_BANNER;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.LOBBY__PRIME_GAME__BUTTON__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.LOBBY__PROMO_SLIDER__BANNER__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.LOBBY__REGISTRATION__FORM__TOUCHED;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.LOBBY__REGISTRATION__FORM__SUBMIT;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.LOBBY__REGISTRATION__FORM__SUCCESS;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.LOBBY__REGISTRATION__FORM__ERROR;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.LOBBY__RANDOM_ZONE__BUTTON__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.LOBBY__FILTER_GAMES__CATEGORY__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.LOBBY__FILTER_GAMES__ALL_THEMES__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.LOBBY__MOBILE_APP_BANNER__LINK__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__REGISTRATION__FORM__APPEARANCE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__REGISTRATION__FORM__TOUCHED;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__REGISTRATION__FORM__SUBMIT;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__REGISTRATION__FORM__SUCCESS;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__REGISTRATION__FORM__ERROR;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__ADDITIONAL_USER_DATA__FORM__APPEARANCE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__ADDITIONAL_USER_DATA__FORM__TOUCHED;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__ADDITIONAL_USER_DATA__FORM__SUBMIT;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__ADDITIONAL_USER_DATA__FORM__SUCCESS;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__ADDITIONAL_USER_DATA__STEP__APPEARANCE;
      attributes?: CommonAttributes;
      dynamicParams: { step: string };
    }
  | {
      name: AnalyticsEventName.LOGIN_APPEARANCE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.LOGIN_TOUCHED;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.LOGIN_SUCCESS;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__LOGIN__FORM__ERROR;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.LU_HOME_TOP;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MOBILE_APP_PAGE__VISIT;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MOBILE_APP_PAGE__ANDROID_APP_ICON__LINK__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MOBILE_APP_PAGE__IOS_APP_ICON__LINK__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.HEADER__BUTTONS__NOTIFICATIONS_BUTTON__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.HEADER__BUTTONS__SUPPORT_BUTTON__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.HEADER__BUTTONS__NAVIGATION_LINK__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.FOOTER__MOBILE_APP__LINK__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.FOOTER__ANDROID_APP_ICON__LINK__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.FOOTER__IOS_APP_ICON__LINK__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.TABBAR__BUTTONS__SUPPORT_BUTTON__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.REG_BUTTON_TOP;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.LOG_IN_TOP;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.DEPOSIT_TOP;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.EMAIL_CONFIRMATION_POPUP__BUTTON_CLOSE__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.EMAIL_CONFIRMATION_POPUP__FIRST_APPEARANCE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.EMAIL_CONFIRMATION_POPUP__SUBSEQUENT_APPEARANCE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.EMAIL_CONFIRMED;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MOBILE_APP_PROMOTION_POPUP__FIRST_APPEARANCE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MOBILE_APP_PROMOTION_POPUP__SUBSEQUENT_APPEARANCE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MOBILE_APP_PROMOTION_POPUP__BUTTON_CLOSE__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MOBILE_APP_PROMOTION_POPUP__IOS_APP__LINK__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MOBILE_APP_PROMOTION_POPUP__ANDROID_APP__LINK__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MOBILE_APP_PROMOTION_POPUP__MOBILE_APP__LINK__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__SEARCH__OVERALL__APPEARANCE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__SEARCH__INPUT__TOUCHED;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__SEARCH__RESULT_SUCCESS__APPEARANCE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__SEARCH__RESULT_FAILURE__APPEARANCE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__SEARCH__OVERALL__CLOSE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__SEARCH__PLAYERS_CHOICE_TAB__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.GAME_SEARCH;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.GAME_ALL_PROVIDERS;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.GAME_ALL_PROVIDERS_PROVIDER;
      attributes?: CommonAttributes;
      dynamicParams: { provider_name: string };
    }
  | {
      name: AnalyticsEventName.TABBAR__BUTTONS__SEARCH_BUTTON__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.GAME_OPEN__ACTIONS_PANEL__SEARCH_BUTTON__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__DEPOSIT__DEPOSIT_BUTTON_STEP_1__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__DEPOSIT__AMOUNT_INPUT__TOUCHED;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__DEPOSIT__PREDEFINED_SUM__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__DEPOSIT__PROMO_CODE_FORM__TOUCHED;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__DEPOSIT__BACK_BUTTON__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__DEPOSIT__PAYMENT_FORM__PREVIOUSLY_USED__CLICK;
      attributes?: CommonAttributes & {
        payment_method_id: string;
        saved_profile_id: string;
      };
    }
  | {
      name: AnalyticsEventName.MODAL__DEPOSIT__SELECTOR_PAYMENT_METHOD__CLICK;
      attributes?: CommonAttributes & {
        payment_method_id: string;
      };
    }
  | {
      name: AnalyticsEventName.MODAL__DEPOSIT__PAYMENT_FORM__ERROR_TEXT;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__DEPOSIT__DEPOSIT_BUTTON_STEP_2__SUBMIT;
      attributes?: CommonAttributes & {
        formValues: string;
      };
    }
  | {
      name: AnalyticsEventName.MODAL__DEPOSIT__PAYMENT_FORM__PREVIOUSLY_USED__TOUCHED;
      attributes?: CommonAttributes & {
        payment_method_id: string | number;
        saved_profile_id: string;
      };
    }
  | {
      name: AnalyticsEventName.MODAL__DEPOSIT__PAYMENT_FORM__SUCCESS_RESPONSE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__DEPOSIT__PAYMENT_FORM__COPY_CRYPTO_ADRESS;
      attributes?: CommonAttributes & {
        crypto_wallet: string;
      };
    }
  | {
      name: AnalyticsEventName.MODAL__DEPOSIT__ATTACHED_BONUS__CLICK;
      attributes?: CommonAttributes & {
        bonus_id: number;
        promocode: any;
      };
    }
  | {
      name: AnalyticsEventName.MODAL__DEPOSIT__PAYMENT_FORM__TOUCHED;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__DEPOSIT__PAYMENT_FORM__FAILURE_RESPONSE;
      attributes?: CommonAttributes & {
        eventId?: string;
        error: string;
      };
    }
  | {
      name: AnalyticsEventName.MODAL__DEPOSIT__PROMO_CODE_FORM__CANCEL;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__DEPOSIT__PROMO_CODE_FORM__ADD;
      attributes?: CommonAttributes & {
        promocode: string;
      };
    }
  | {
      name: AnalyticsEventName.MODAL__DEPOSIT__TURN_ON_BONUSES__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__DEPOSIT__TURN_OFF_BONUSES__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.GAME_OPEN__ACTIONS_PANEL__DEPOSIT_BUTTON__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.GAME_OPEN__ACTIONS_PANEL__FAVORITE_BUTTON__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.GAME_OPEN__ACTIONS_PANEL__WAGER_LABEL__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.PROMO__PROMOCODE_ACTIVATION__SUCCESS;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.PROMO__PROMOCODE_ACTIVATION__FAILURE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.PROMO__TAB__SELECTION;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.PROMO__BONUS_CARD__ACTIVATE__SUCCESS;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.PROMO__BONUS_CARD__ACTIVATE__FAILURE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.PROMO__BONUS_CARD__CANCEL__SUCCESS;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.PROMO__BONUS_CARD__CANCEL__FAILURE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.PROMO__BONUS_CARD__PLAY;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.PROMO__EXCHANGE_CP_MODAL__EXCHANGE__SUCCESS;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.PROMO__EXCHANGE_CP_MODAL__EXCHANGE__FAILURE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.PROFILE__VERIFICATION__UPLOADER__UPLOAD;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.PROFILE__VERIFICATION__ERROR__SHOW;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.PROFILE__NAVBAR__LINK__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.PROFILE__SECURITY__2FA__ACTIVATE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.PROFILE__SECURITY__CHANGE_PASSWORD__SUCCESS;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.PROFILE__PERSONAL__PROMOTIONAL_SETTINGS_SWITCHER__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.PROFILE__PERSONAL__FORM_SUBMIT__ERROR;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.PROFILE__PERSONAL__FORM_SUBMIT__SUCCESS;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__WITHDRAW__SUBMIT_BUTTON__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__DEPOSIT__CLOSE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__DEPOSIT_EXIT_POPUP__ACTIVATE_BONUS__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__DEPOSIT_EXIT_POPUP__CLOSE_CROSS__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__DEPOSIT_EXIT_POPUP__APPEARANCE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__DEPOSIT_EXIT_POPUP__BUTTON_CLOSE__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__REG_EXIT_POPUP1__REGISTER__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__REG_EXIT_POPUP1_CROSS__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__REG_EXIT_POPUP1__APPEARANCE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__REG_EXIT_POPUP__APPEARANCE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__REG_EXIT_POPUP__CLOSE_CROSS__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__REG_EXIT_POPUP__YES__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__REG_EXIT_POPUP_NO__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__DEPOSIT__OVERALL__APPEARANCE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__GENDER_SELECT__APPEARANCE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__GENDER_SELECT__FORM__SUBMIT;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.HEADER__SIGN_OUT__BUTTON__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.TABBAR__SIGN_OUT__BUTTON__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__LOGIN__GOOGLE_AUTH_BUTTON_CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__WELCOME_BACK__GOOGLE_AUTH_BUTTON_CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__REGISTRATION__GOOGLE_AUTH_BUTTON_CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__REGISTRATION__BONUS_REGISTER__BUTTON__CLICK;
      attributes?: CommonAttributes;
    };

const ANALYTICS_URL = CLIENT_ENVS.ANALYTICS_URL;

export const pushAnalytics = (data: EventWithPayload) => {
  const BASE_URL = ANALYTICS_URL ? ANALYTICS_URL + '/' : '';

  return request<null>({
    method: 'POST',
    url: `${BASE_URL}analytics`,
    data: snakify(data),
  });
};

interface ABTesting {
  experiment: string;
  version: string;
  attributes: {
    sessionId: string;
    userId?: number;
    createdAt?: number; // field is required for the backend
    updatedAt?: number; // field is required for the backend
  };
}

export const pushABTesting = (data: ABTesting) => {
  const BASE_URL = ANALYTICS_URL ? ANALYTICS_URL + '/' : '';

  return request<null>({
    method: 'POST',
    url: `${BASE_URL}ab-testing`,
    data: snakify(data),
  });
};
